import React, { useEffect, useState, useRef } from 'react';
import { getHPTs, getPTWs, getPTWStats } from '../api/dashboardService';
import { logout, cambiarPassword } from '../api/authService';
import { useNavigate } from 'react-router-dom';
import '../styles/HptScreens.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import SignaturePad from '../components/SignaturePad';


// BackEnd de Serveless
const API_URL = process.env.REACT_APP_API_URL;

// ============================================================================
// COMPONENTE PRINCIPAL: DashboardScreen
// ============================================================================
const DashboardScreen = () => {
    // --- ESTADOS DE DATOS ---
    const [ptws, setPtws] = useState([]);   // Lista de todos los Permisos de Trabajo
    const [hpts, setHpts] = useState([]);   // Lista de todas las Hojas de Planificación
    const [totalAnual, setTotalAnual] = useState(0);
    
    // --- ESTADOS DE NAVEGACIÓN Y MENÚS ---
    const [menuOpen, setMenuOpen] = useState(false);         // Menú tipo hamburguesa
    const [userMenuOpen, setUserMenuOpen] = useState(false); // Menú de usuario
    const [showPendingList, setShowPendingList] = useState(false); // Control de mini-lista de varias firmas pendientes.
    const [showProfile, setShowProfile] = useState(false); // Menu Vista Perfil
    const [showChangePass, setShowChangePass] = useState(false); // Control Vista Cambio Contraseña

    // --- ESTADOS DEL FORMULARIO DE CONTRASEÑA ---
    const [passwords, setPasswords] = useState({ actual: '', nueva: '', confirmacion: '' });
    const [passMsg, setPassMsg] = useState({ error: '', success: '' });
    
    // --- ESTADOS DE BÚSQUEDA EN VIVO ---
    const [searchPTW, setSearchPTW] = useState(''); // Texto escrito en buscador PTW
    const [searchHPT, setSearchHPT] = useState(''); // Texto escrito en buscador HPT
    const [filterGroup, setFilterGroup] = useState(''); // Para Filtrar por Grupo

    // --- ESTADOS DE LAS FIRMAS GUARDADAS ---
    const [firmaGuardada, setFirmaGuardada] = useState(null);
    const [showSignaturePad, setShowSignaturePad] = useState(false);

    // Referencia CLICKS Fuera de Menus
    const menuRef = useRef(null);
    const userRef = useRef(null);
    const navigate = useNavigate();

    // --- ESTADOS DEL MODAL DE ANEXOS ---
    const [showAnexosModal, setShowAnexosModal] = useState(false);
    const [anexoSeleccionado, setAnexoSeleccionado] = useState(null);
    const [listaAnexos, setListaAnexos] = useState([]);
    const [loadingAnexos, setLoadingAnexos] = useState(false);

    // --- ESTADO PARA DESPLEGABLE DE CONTEO ---
    const [showHptCounts, setShowHptCounts] = useState(false);
    const counterHptRef = useRef(null);

    const [showPtwCounts, setShowPtwCounts] = useState(false);
    const [filterGroupPTW, setFilterGroupPTW] = useState('');
    const counterPtwRef = useRef(null);

    // --- ESTADOS PARA CREAR USUARIOS ---
    const [showUserModal, setShowUserModal] = useState(false);
    const [newUser, setNewUser] = useState({ usuario: '', correo: '', nombre: '', apellidos: '', rol: '', grupo: '' });

    // --- ESTADOS PARA DELEGACIÓN DE VACACIONES ---
    const [usuariosList, setUsuariosList] = useState([]); 
    const [misDelegaciones, setMisDelegaciones] = useState([]); 
    const [misSuplenciasActivas, setMisSuplenciasActivas] = useState([]); 
    const [nuevaDelegacion, setNewDelegacion] = useState({ id_suplente: '', fecha_inicio: '', fecha_fin: '' });

    // --- ESTADOS DE RESULTADOS DE BÚSQUEDA DEL SERVIDOR ---
    const [hptsBuscador, setHptsBuscador] = useState([]);
    const [ptwsBuscador, setPtwsBuscador] = useState([]);

    // --- ESTADOS PARA EL MODAL DE SOLICITUD DE COMPRAS ---
    const [showComprasModal, setShowComprasModal] = useState(false);
    const [compras, setCompras] = useState([]);
    const [loadingCompras, setLoadingCompras] = useState(false);
    const [searchCompra, setSearchCompra] = useState('');
    const [filterPendiente, setFilterPendiente] = useState('');


    // Para control del banner de firmas pendientes.
    let currentUser = {};
    const token = localStorage.getItem('userToken');
    if (token) {
        try {
            currentUser = JSON.parse(atob(token.split('.')[1]));
        } catch(e) {
            console.error("Error leyendo token");
        }
    }

    // Datos del usuario logueado sacados del almacenamiento local (creados al hacer Login)
    const nameUser = currentUser.user ||'Usuario';
    const userRol = currentUser.rol;

    // Si no están en localStorage, caemos de vuelta a leerlos del Token decodificado
    const uGrupo = currentUser.grupo;
    const uId = parseInt(currentUser.id);

    const perfilUsuario = {
        usuario: currentUser.user || nameUser,
        nombre: currentUser.user_name || '',
        apellidos: currentUser.user_apelli || '',
        correo: currentUser.user_correo || 'No especificado',
        rol: userRol || 'No asignado',
        grupo: uGrupo || 'No asignado'
    };
    
    // Fecha de hoy formateada como texto "YYYY-MM-DD"
    const hoy = new Date().toISOString().split('T')[0];

    // Cargar compras
    const handleCargarCompras = async () => {
        setLoadingCompras(true);
        try {
            const res = await axios.get(`${API_URL}/api/compras`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setCompras(res.data);
        } catch (error) {
            console.error("Error cargando compras:", error);
            setCompras([]);
        } finally {
            setLoadingCompras(false);
        }
    };

    const handleDeleteCompra = async (idSolicitud) => {
        const confirm = await Swal.fire({
            title: '¿Eliminar Solicitud?',
            text: `Estás a punto de borrar permanentemente la solicitud de compra #${idSolicitud}. Esta acción no se puede deshacer.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d32f2f',
            cancelButtonColor: '#999',
            confirmButtonText: 'Sí, borrar definitivamente',
            cancelButtonText: 'Cancelar'
        });

        if (confirm.isConfirmed) {
            try {
                await axios.delete(`${API_URL}/api/compras/${idSolicitud}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                
                setCompras(prevCompras => prevCompras.filter(c => c.id_solicitud !== idSolicitud));
                
                Swal.fire({
                    title: '¡Borrado!',
                    text: 'La solicitud ha sido eliminada.',
                    icon: 'success',
                    confirmButtonColor: '#003366',
                    timer: 2000
                });
            } catch (error) {
                console.error("Error al borrar compra:", error);
                Swal.fire('Error', error.response?.data?.error || 'No se pudo eliminar la solicitud.', 'error');
            }
        }
    };

    const handleCargarListaAnexos = async (tipoRuta) => {
        setAnexoSeleccionado(tipoRuta);
        setLoadingAnexos(true);
        try {
            const token = localStorage.getItem('userToken');
            const res = await axios.get(`${API_URL}/api/hpt/anexos/listar/${tipoRuta}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setListaAnexos(res.data);
        } catch (error) {
            console.error("Error al cargar la lista de anexos", error);
            setListaAnexos([]);
        } finally {
            setLoadingAnexos(false);
        }
    };

    const handleNewUserChange = (e) => setNewUser({...newUser, [e.target.name]: e.target.value});

    const handleCreateUser = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('userToken');
            await axios.post(`${API_URL}/auth/crear-usuario`, newUser, {
                headers: { Authorization: `Bearer ${token}` }
            });
            Swal.fire('¡Usuario Creado!', 'El usuario se ha creado con éxito. Recuerda que su contraseña es: AstesAB', 'success');
            setShowUserModal(false);
            setNewUser({ usuario: '', correo: '', nombre: '', apellidos: '', rol: '', grupo: '' });
        } catch (error) {
            Swal.fire('Error', error.response?.data?.error || 'No se pudo crear el usuario', 'error');
        }
    };

    // Delegaciones de responsabilidades por vacaciones
    const handleCrearDelegacion = async () => {
        if (!nuevaDelegacion.id_suplente || !nuevaDelegacion.fecha_inicio || !nuevaDelegacion.fecha_fin) {
            return Swal.fire('Aviso', 'Rellena todos los campos de fechas y usuario', 'warning');
        }
        try {
            const token = localStorage.getItem('userToken');
            await axios.post(`${API_URL}/auth/${uId}/delegaciones`, nuevaDelegacion, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const res = await axios.get(`${API_URL}/auth/${uId}/delegaciones`, { headers: { Authorization: `Bearer ${token}` }});
            setMisDelegaciones(res.data);
            setNewDelegacion({ id_suplente: '', fecha_inicio: '', fecha_fin: '' });
            Swal.fire('Guardado', 'Vacaciones programadas correctamente.', 'success');
        } catch (error) { Swal.fire('Error', error.response?.data?.error || 'Error al guardar', 'error'); }
    };

    const handleEliminarDelegacion = async (idDelegacion) => {
        try {
            const token = localStorage.getItem('userToken');
            await axios.delete(`${API_URL}/auth/delegaciones/${idDelegacion}`, { headers: { Authorization: `Bearer ${token}` }});
            setMisDelegaciones(prev => prev.filter(d => d.id_delegacion !== idDelegacion));
        } catch (error) { Swal.fire('Error', 'No se pudo borrar', 'error'); }
    };
    
    // ============================================================================
    // EFECTOS DE ARRANQUE
    // ============================================================================
    useEffect(() => {
        // Carga de los datos del Dhasboard
        const fetchData = async () => {
            const token = localStorage.getItem('userToken');
            const config = { headers: { Authorization: `Bearer ${token}` } };
            try {
                // Todo en riguroso paralelo (0 impacto en rendimiento)
                const [listaCompleta, resUsers, resDeleg, resSupl, resFirma] = await Promise.all([
                    getHPTs(),
                    axios.get(`${API_URL}/api/catalogos/usuarios`, config),
                    axios.get(`${API_URL}/auth/${uId}/delegaciones`, config),
                    axios.get(`${API_URL}/auth/${uId}/mis-suplencias-activas`, config),
                    axios.get(`${API_URL}/auth/${uId}/firma`, config)
                ]);
                
                setHpts(listaCompleta);
                setUsuariosList(resUsers.data);
                setMisDelegaciones(resDeleg.data);
                setMisSuplenciasActivas(resSupl.data);
                
                if (resFirma.data.hasSignature) setFirmaGuardada(resFirma.data.firma_path);
            } catch (err) { console.error("Error en carga:", err); }
        };
        fetchData();

        // LÓGICA DE MENÚS: Cierre menus despolegables si se hace click fuera
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) setMenuOpen(false);
            if (userRef.current && !userRef.current.contains(event.target)) setUserMenuOpen(false);
            if (counterHptRef.current && !counterHptRef.current.contains(event.target)) setShowHptCounts(false);
            if (counterPtwRef.current && !counterPtwRef.current.contains(event.target)) setShowPtwCounts(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        
        // Limpiamos el listener cuando se cierra menus para no saturar.
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // --- EFECTO DE BÚSQUEDA HPT AL SERVIDOR ---
    useEffect(() => {
        if (searchHPT.trim().length >= 2) {
            const delayDebounceFn = setTimeout(async () => {
                try {
                    const res = await axios.get(`${API_URL}/api/hpt/buscar/historial?q=${searchHPT}`, {
                        headers: { Authorization: `Bearer ${localStorage.getItem('userToken')}` }
                    });
                    setHptsBuscador(res.data);
                } catch (e) { console.error("Error buscando HPT"); }
            }, 400); // Espera 400ms para buscar
            return () => clearTimeout(delayDebounceFn);
        } else {
            setHptsBuscador([]); // Limpiamos si borra el buscador
        }
    }, [searchHPT]);

    // --- EFECTO DE BÚSQUEDA PTW AL SERVIDOR ---
    useEffect(() => {
        if (searchPTW.trim().length >= 2) {
            const delayDebounceFn = setTimeout(async () => {
                try {
                    const res = await axios.get(`${API_URL}/api/ptw/buscar/historial?q=${searchPTW}`, {
                        headers: { Authorization: `Bearer ${localStorage.getItem('userToken')}` }
                    });
                    setPtwsBuscador(res.data);
                } catch (e) { console.error("Error buscando PTW"); }
            }, 400);
            return () => clearTimeout(delayDebounceFn);
        } else {
            setPtwsBuscador([]);
        }
    }, [searchPTW]);


    // ============================================================================
    // LÓGICA de banner de Pdt Firmar
    // ============================================================================
    const meTocaFirmar = (hpt) => {
        if (!hpt || hpt.pendiente_de === "COMPLETO") return false;

        const paso = hpt.pendiente_de;


        const evaluarPermisos = (evalRol, evalGrupo, evalId) => {
            if (evalRol === 'ADMINISTRADOR') return true; 

            const creadorEsElectrico = ['ELECTRICOS','SPElectrico'].includes(hpt.creador_grupo);
            const creadorEsMecanico = ['MECANICO','SPMecanico'].includes(hpt.creador_grupo);
            const creadorEsInstrumentacion = ['INSTRUMENTACION', 'SPInstrumentacion'].includes(hpt.creador_grupo);
            const creadorEsCampoSolar = ['CAMPO SOLAR', 'SPCampoSolar'].includes(hpt.creador_grupo);
            const creadorEsQuimico = ['QUIMICO', 'SPQuimico'].includes(hpt.creador_grupo);

            // Los Administradores siempre pueden firmar por cualquiera
            if (userRol === 'ADMINISTRADOR') return true;

            switch (paso) {
                case 'SOLICITANTE':
                    // Si el creador es del mismo grupo
                    if (hpt.creador_grupo === evalGrupo) return true;
                    // Si es creado en el Departamento de Operación puede firmar cualquiera del departamento
                    if (
                        ((hpt.creador_grupo === 'JEFE_TURNO') || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Operacion') || (hpt.creador_rol === 'OFICIAL' && hpt.creador_grupo === 'OPERACION')) && 
                        (evalGrupo === 'JEFE TURNO' || (evalRol === 'GESTOR' || evalGrupo === 'Operacion') || (evalRol === 'OFICIAL' && evalGrupo === 'OPERACION'))
                    ) return true;
                    // Si es creador en el Departamento de Mantenimiento puede firmar Oficiales de Su grupo o Responsables directos.
                    if (
                        (creadorEsElectrico || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento') || hpt.creador_rol === 'SUPERVISOR') && 
                        ((evalRol === 'GESTOR' && evalGrupo === 'Mantenimiento') || (evalRol === 'OFICIAL' && (evalGrupo === 'ELECTRICOS')) || evalRol === 'SUPERVISOR')
                    ) return true;
                    if (
                        (creadorEsMecanico || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento') || hpt.creador_rol === 'SUPERVISOR') && 
                        ((evalRol === 'GESTOR' && evalGrupo === 'Mantenimiento') || (evalRol === 'OFICIAL' && (evalGrupo === 'MECANICO')) || evalRol === 'SUPERVISOR')
                    ) return true;
                    if (
                        (creadorEsInstrumentacion || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento') || hpt.creador_rol === 'SUPERVISOR') && 
                        ((evalRol === 'GESTOR' && evalGrupo === 'Mantenimiento') || (evalRol === 'OFICIAL' && (evalGrupo === 'INSTRUMENTACION')) || evalRol === 'SUPERVISOR')
                    ) return true;
                    if (
                        (creadorEsCampoSolar || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento') || hpt.creador_rol === 'SUPERVISOR') && 
                        ((evalRol === 'GESTOR' && evalGrupo === 'Mantenimiento') || (evalRol === 'OFICIAL' && (evalGrupo === 'CAMPO SOLAR')) || evalRol === 'SUPERVISOR')
                    ) return true;
                    if (
                        (creadorEsQuimico || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento') || hpt.creador_rol === 'SUPERVISOR') && 
                        ((evalRol === 'GESTOR' && evalGrupo === 'Mantenimiento') || (evalRol === 'OFICIAL' && (evalGrupo === 'QUIMICO')) || evalRol === 'SUPERVISOR')
                    ) return true;

                    return false;

                case 'RESP_SUBCONTRATA':
                    // Si la persona logueada es el RESP_SUBCONTRATA INDICADO
                    if (hpt.id_usuario_subcontrata && uId === hpt.id_usuario_subcontrata) return true;
                    // Jefe TURNO puede firmar, si la creo él mismo o el Responsable de Operación u Oficial Operacion
                    if (userRol === 'JEFE_TURNO' && 
                        (hpt.creador_rol === 'JEFE_TURNO' || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Operacion') || (hpt.creador_rol === 'OFICIAL' && hpt.creador_grupo === 'OPERACION'))
                    ) return true;
                    // Si es un oficial, puede firmar si pertenece a su grupo o si la creo el supervisor de su grupo o la creo el Responsable de Mantenimiento.
                    if (userRol === 'OFICIAL' && 
                        (evalGrupo === hpt.creador_grupo || (creadorEsMecanico && evalGrupo === 'MECANICO') || (creadorEsElectrico && evalGrupo === 'ELECTRICOS') || (creadorEsInstrumentacion && evalGrupo === 'INSTRUMENTACION')  || (creadorEsCampoSolar && evalGrupo === 'CAMPO SOLAR')  || (creadorEsQuimico && evalGrupo === 'QUIMICO')  || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento'))
                    ) return true; 
                    return false;

                case 'PREVENCION':
                    // Solo Prevencion o Responsables de Operacion o Mantenimiento pueden firmar este apartado
                    if (evalRol === 'PREVENCION' || evalRol === 'GESTOR' || evalRol === 'CALIDAD') return true;
                    return false;

                case 'SUPERVISOR':
                    // Lógica de Responsable (Mantenimiento)
                    if (
                        evalRol === 'GESTOR' && evalGrupo === 'Mantenimiento' && 
                        (creadorEsMecanico || creadorEsElectrico || creadorEsCampoSolar || creadorEsInstrumentacion || creadorEsQuimico || hpt.creador_rol === "SUPERVISOR" || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento'))
                    ) return true;
                    
                    // Lógica de Responsable (Operacion)
                    if(
                        evalRol === 'GESTOR' && evalGrupo === 'Operacion' && 
                        (hpt.creador_rol === "JEFE_TURNO" || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Operacion') ||(hpt.creador_rol === 'OFICIAL' && hpt.creador_grupo === 'OPERACION'))
                    ) return true;
                    
                    // Si el logueado es SUPERVISOR, solo firma si es del mismo departamento
                    if (userRol === 'SUPERVISOR') {
                        if (creadorEsMecanico || creadorEsElectrico || creadorEsCampoSolar || creadorEsInstrumentacion || creadorEsQuimico || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento') ||  hpt.creador_rol === 'SUPERVISOR') return true;
                    }
                    return false;

                case 'JEFE_TURNO':
                    // Última firma: Exclusiva del Jefe de Turno o responsable de Operación
                    return evalRol === 'JEFE_TURNO' || (evalRol === 'GESTOR' && evalGrupo === 'Operacion');

                default:
                    return false;
            }

        };

        if (evaluarPermisos(userRol, uGrupo, uId)) return true;

        if (misSuplenciasActivas && misSuplenciasActivas.length > 0) {
            for (let s of misSuplenciasActivas) {
                if (evaluarPermisos(s.rol, s.grupo, s.id_usuario)) return true;
            }
        }
        return false;

    };

    // ============================================================================
    // FUNCION: BORRAR HPT (Solo Administrador y Gestor)
    // ============================================================================
    const handleDeleteHPT = async (idHpt, otReferencia) => {
        const confirm = await Swal.fire({
            title: '¿Eliminar Planificación?',
            text: `Estás a punto de borrar permanentemente la HPT de la OT: ${otReferencia}. Esta acción no se puede deshacer y borrará también sus documentos adjuntos.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d32f2f',
            cancelButtonColor: '#999',
            confirmButtonText: 'Sí, borrar definitivamente',
            cancelButtonText: 'Cancelar'
        });

        if (confirm.isConfirmed) {
            try {
                const token = localStorage.getItem('userToken');
                await axios.delete(`${API_URL}/api/hpt/${idHpt}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                
                // Quitamos la HPT borrada del estado actual
                setHpts(prevHpts => prevHpts.filter(h => h.id_hpt !== idHpt));
                
                Swal.fire({
                    title: '¡Borrado!',
                    text: 'La planificación ha sido eliminada del sistema.',
                    icon: 'success',
                    confirmButtonColor: '#003366',
                    timer: 2000
                });
            } catch (error) {
                console.error("Error al borrar HPT:", error);
                Swal.fire({
                    title: 'Error',
                    text: error.response?.data?.error || 'No se pudo eliminar la planificación.',
                    icon: 'error',
                    confirmButtonColor: '#003366'
                });
            }
        }
    };

    // ============================================================================
    // LÓGICA DE CONTEOS Y ESTADÍSTICAS
    // ============================================================================
    const ptwsTotalCount = ptws.length;
    const ptwsNoCerradosCount = ptws.filter(p => p.estado !== 'cerrado').length;

    const hptsTotalCount = hpts.length;
    const hptsNoFinalizadasCount = hpts.filter(h => h.fecha_prevista && h.fecha_prevista > hoy).length;

    // ============================================================================
    // LÓGICA DE BUSCADORES INTELIGENTES (PTW)
    // ============================================================================
    let ptwsParaMostrar = [];
    if (searchPTW.trim().length >= 2) {
        ptwsParaMostrar = ptwsBuscador;
    } else if (filterGroupPTW) {
        ptwsParaMostrar = ptws.filter(p => {
            if (filterGroupPTW === 'QUIMICO') return p.creador_grupo === 'QUIMICO' || p.creador_grupo === 'SPQuimico';
            if (filterGroupPTW === 'MECANICO') return p.creador_grupo === 'MECANICO' || p.creador_grupo === 'SPMecanico';
            if (filterGroupPTW === 'CAMPO SOLAR') return p.creador_grupo === 'CAMPO SOLAR' || p.creador_grupo === 'SPCampoSolar';
            if (filterGroupPTW === 'ELECTRICOS') return p.creador_grupo === 'ELECTRICOS' || p.creador_grupo === 'SPElectrico';
            if (filterGroupPTW === 'INSTRUMENTACION') return p.creador_grupo === 'INSTRUMENTACION' || p.creador_grupo === 'SPInstrumentacion';
            if (filterGroupPTW === 'OPERACION') return p.creador_grupo === 'Operacion' || p.creador_grupo === 'OPERACION' || p.creador_grupo === 'JEFE_TURNO';
            return p.creador_grupo === filterGroupPTW;
        });
    } else {
        ptwsParaMostrar = ptws;
    }

    // ============================================================================
    // LÓGICA DE BUSCADORES INTELIGENTES (HPT)
    // ============================================================================

    let hptsParaMostrar = [];
    if (searchHPT.trim().length >= 2) {
        hptsParaMostrar = hptsBuscador;
    } else if (filterGroup) {
        hptsParaMostrar = hpts.filter(h => {
            if (filterGroup === 'QUIMICO') return h.creador_grupo === 'QUIMICO' || h.creador_grupo === 'SPQuimico';
            if (filterGroup === 'MECANICO') return h.creador_grupo === 'MECANICO' || h.creador_grupo === 'SPMecanico';
            if (filterGroup === 'CAMPO SOLAR') return h.creador_grupo === 'CAMPO SOLAR' || h.creador_grupo === 'SPCampoSolar';
            if (filterGroup === 'ELECTRICOS') return h.creador_grupo === 'ELECTRICOS' || h.creador_grupo === 'SPElectrico';
            if (filterGroup === 'INSTRUMENTACION') return h.creador_grupo === 'INSTRUMENTACION' || h.creador_grupo === 'SPInstrumentacion';
            if (filterGroup === 'OPERACION') return h.creador_grupo === 'Operacion' || h.creador_grupo === 'OPERACION' || h.creador_grupo === 'JEFE_TURNO';
            return h.creador_grupo === filterGroup;
        });
    } else {
        hptsParaMostrar = hpts; // Hpts ya vienen filtradas desde el servidor con las vivas
    }

    hptsParaMostrar = [...hptsParaMostrar].sort((a, b) => {
        const aEsCompleto = a.pendiente_de === 'COMPLETO';
        const bEsCompleto = b.pendiente_de === 'COMPLETO';

        if (aEsCompleto && !bEsCompleto) return 1;  
        if (!aEsCompleto && bEsCompleto) return -1;

        if (!a.fecha_prevista) return 1;
        if (!b.fecha_prevista) return -1;
        
        return new Date(a.fecha_prevista) - new Date(b.fecha_prevista); 
    });

    // ============================================================================
    // ALERTAS DINÁMICAS (Banner Superior)
    // ============================================================================
    // Busca si hay alguna HPT que le toque firmar que este pendiente
    const hptsPendientesMiFirma = hpts.filter(h => meTocaFirmar(h));

    // Configuración visual de los estados de un PTW
    const getStatusConfig = (estado) => {
        switch (estado) {
            case 'cerrado': return { icon: '🏁', color: '#d32f2f' }; // Rojo
            case 'abierto': return { icon: '🔓', color: '#2e7d32' }; // Verde
            case 'renovado': return { icon: '⏳', color: '#1a237e' };// Azul Oscuro
            default: return { icon: '📝', color: '#f57c00' };        // Naranja
        }
    };

    // ============================================================================
    // ACTUALIZAR CONTRASEÑA
    // ============================================================================
    const handleUpdatePassword = async (e) => {
        e.preventDefault();
        setPassMsg({ error: '', success: '' });

        if (passwords.nueva !== passwords.confirmacion) {
            return setPassMsg({ error: 'Las contraseñas nuevas no coinciden.', success: '' });
        }
        if (passwords.nueva.length < 6) {
            return setPassMsg({ error: 'La contraseña debe tener al menos 6 caracteres.', success: '' });
        }

        try {
            await cambiarPassword(uId, token, passwords.actual, passwords.nueva);

            setPassMsg({ error: '', success: '¡Contraseña actualizada!' });
            setTimeout(() => {
                setShowChangePass(false);
                setPasswords({ actual: '', nueva: '', confirmacion: '' });
                setPassMsg({ error: '', success: '' });
            }, 2000);

        } catch (err) {
            setPassMsg({ 
                error: typeof err === 'string' ? err : 'Error al actualizar la contraseña.', 
                success: '' 
            });
        }
    };

    // ============================================================================
    // Mostrar y Actualizar Firma
    // ============================================================================
    // Funcion para obtener la firma
    const fetchFirmaUsuario = async () => {
        const token = localStorage.getItem('userToken');
        if (!uId) return;

        try {
            const res = await axios.get(`${API_URL}/auth/${uId}/firma`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (res.data.hasSignature) {
                setFirmaGuardada(res.data.firma_path);
            }
        } catch (error) {
            console.warn("No se pudo obtener la firma guardada");
        }
    };

    // Funcion para guardar la nueva firma
    const handleGuardarFirma = async (firmaBase64) => {
        setShowSignaturePad(false);
        const token = localStorage.getItem('userToken');
        if (!uId) {
            Swal.fire('Error', 'No se ha podido identificar al usuario.', 'error');
            return;
        }

        try {
            await axios.post(`${API_URL}/auth/${uId}/firma`, {
                firma_path: firmaBase64
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setFirmaGuardada(firmaBase64); // Actualizamos la imagen en el desplegable
            
            Swal.fire({
                title: "¡Guardada!",
                text: "Tu firma maestra se ha actualizado correctamente.",
                icon: "success",
                confirmButtonColor: '#003366',
                timer: 2000
            });
        } catch (error) {
            Swal.fire('Error', 'No se pudo guardar la firma en el servidor.', 'error');
        }
    };

    // ============================================================================
    // Desglose por grupo
    // ============================================================================
    const desgloseHpts = hpts.reduce((acc, hpt) => {
        const grupo = hpt.creador_grupo;
        if (grupo) {
            acc[grupo] = (acc[grupo] || 0) + 1;
        }
        return acc;
    }, {});

    const desgloseHptsNuevas = hpts.reduce((acc, hpt) => {
        const grupo = hpt.creador_grupo;
        
        // Si no hay grupo o no hay fecha, lo saltamos
        if (!grupo || !hpt.fecha_prevista || !hpt.dias_previstos) return acc;

        // Calculamos la fecha límite (Fecha prevista + días previstos)
        const fechaLimite = new Date(hpt.fecha_prevista);
        // Le restamos 1 para que si es "1 día", empiece y acabe mismo dia
        fechaLimite.setDate(fechaLimite.getDate() + (hpt.dias_previstos - 1));
        
        // Extraemos la fecha de hoy (solo YYYY-MM-DD)
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        fechaLimite.setHours(0, 0, 0, 0);

        // Comprobamos: Si la fecha límite es HOY o mas adelante la contamos
        if (fechaLimite >= hoy) {
            acc[grupo] = (acc[grupo] || 0) + 1;
        }
        return acc;
    }, {});

    // ============================================================================
    // Filtrar Por grupo
    // ============================================================================
    const handleFiltroRapido = (grupo) => {
        setFilterGroup(grupo);
        setSearchHPT('');
        setShowHptCounts(false);
    };
    
    // ============================================================================
    // Desglose por grupo (PTW)
    // ============================================================================
    const desglosePtws = ptws.reduce((acc, ptw) => {
        const grupo = ptw.creador_grupo;
        if (grupo) {
            acc[grupo] = (acc[grupo] || 0) + 1;
        }
        return acc;
    }, {});

    const handleFiltroRapidoPTW = (grupo) => {
        setFilterGroupPTW(grupo);
        setSearchPTW(''); // Limpiamos el buscador de texto
        setShowPtwCounts(false); // Cerramos el desplegable
    };

    // ============================================================================
    // Filtrado de Compras
    // ============================================================================

    const comprasFiltradas = compras.filter(c => {
        // 1. Filtrado por texto (Buscador)
        const q = searchCompra.toLowerCase();
        const refId = `#${c.id_solicitud}`.toLowerCase();
        const deptoTexto = (c.departamento || '').toLowerCase();
        const tipo = (c.tipo_solicitud || '').toLowerCase();
        const solNom = `${c.solicitante_nombre || ''} ${c.solicitante_apellidos || ''}`.toLowerCase();
        const just = (c.justificacion || '').toLowerCase();
        const tit = (c.titulo || '').toLowerCase();
        const numPedido = (c.numero_pedido || '').toLowerCase();
        const refPresupuesto = (c.ref_presupuesto || '').toLowerCase();
        
        const cumpleTexto = refId.includes(q) || deptoTexto.includes(q) || tipo.includes(q) || solNom.includes(q) || just.includes(q) || tit.includes(q) || numPedido.includes(q) || refPresupuesto.includes(q);

        // 2. Filtrado por Departamento (Selector)
        let cumpleDepartamento = true;
        if (filterGroup) {
            if (filterGroup === 'QUIMICO') cumpleDepartamento = c.departamento === 'QUIMICO';
            else if (filterGroup === 'MECANICO') cumpleDepartamento = c.departamento === 'MECANICO';
            else if (filterGroup === 'CAMPO SOLAR') cumpleDepartamento = c.departamento === 'CAMPO SOLAR';
            else if (filterGroup === 'ELECTRICOS') cumpleDepartamento = c.departamento === 'ELECTRICOS';
            else if (filterGroup === 'INSTRUMENTACION') cumpleDepartamento = c.departamento === 'INSTRUMENTACION';
            else if (filterGroup === 'OPERACION') cumpleDepartamento = c.departamento === 'OPERACION';
            else if (filterGroup === 'PREVENCION') cumpleDepartamento = c.departamento === 'PRL';
            else cumpleDepartamento = false; 
        }

        // 3. Filtrado por Pendiente de firma
        let cumplePendiente = true;
        if (filterPendiente) {
            cumplePendiente = c.pendiente_de === filterPendiente;
        }

        return cumpleTexto && cumpleDepartamento && cumplePendiente;
    });
    const comprasEnProceso = comprasFiltradas.filter(c => c.estado === 'PROCESO' || c.pendiente_de !== 'COMPLETO');
    const comprasTerminadas = comprasFiltradas.filter(c => c.estado === 'TERMINADA' || c.pendiente_de === 'COMPLETO');


    // ============================================================================
    // 🎨 RENDER (HTML/JSX)
    // ============================================================================
    return (
        <div className="dashboard-wrapper">
            {/* --- NAVBAR FIJO --- */}
            <nav className="navbar-main">
                {/* Menú de Creación (Hamburguesa Izquierda) */}
                <div className="nav-section" ref={menuRef}>
                    <button onClick={() => setMenuOpen(!menuOpen)} className="burger-btn">☰</button>
                    {menuOpen && (
                        <div className="dropdown-menu">
                            {/* Menú visible para ADMINISTRACION */}
                            {userRol === 'ADMINISTRACION' ? (
                                <div className="dropdown-item" onClick={() => {
                                    setMenuOpen(false);
                                    handleCargarCompras();
                                    setShowComprasModal(true);
                                }}>
                                    📦 Solicitud Compras
                                </div>
                            ) : (
                                <>
                                    {['ADMINISTRADOR', 'GESTOR', 'JEFE_TURNO'].includes(userRol) && (
                                        <div className="dropdown-item" onClick={() => navigate('/crear-ptw-directo')}>⚡ Nuevo permiso directo</div>
                                    )}
                                    {['ADMINISTRADOR', 'PREVENCION', 'CALIDAD', 'GESTOR', 'SUPERVISOR', 'JEFE_TURNO', 'OFICIAL'].includes(userRol) && (
                                        <div className="dropdown-item" onClick={() => navigate('/crear-hpt')}>📝 Nueva Planificación (HPT)</div>
                                    )}
                                    <div className="dropdown-item" onClick={() => navigate('/planificador')}>🪛 Planificador</div>
                                    
                                    {['ADMINISTRADOR', 'PREVENCION', 'CALIDAD', 'GESTOR', 'SUPERVISOR', 'JEFE_TURNO', 'OFICIAL'].includes(userRol) && (
                                        <div className="dropdown-item" onClick={() => {
                                            setMenuOpen(false);
                                            setAnexoSeleccionado(null);
                                            setShowAnexosModal(true);
                                        }}>📋 Anexos y Permisos</div>
                                    )}

                                    {['ADMINISTRADOR', 'GESTOR', 'SUPERVISOR', 'JEFE_TURNO', 'OFICIAL', 'PREVENCION', 'CALIDAD','ADMINISTRACION'].includes(userRol) && (
                                        <div className="dropdown-item" onClick={() => {
                                            setMenuOpen(false);
                                            handleCargarCompras();
                                            setShowComprasModal(true);
                                        }}>
                                            📦 Solicitud Compras
                                        </div>
                                    )}

                                    {['ADMINISTRADOR', 'GESTOR'].includes(userRol) && (
                                        <div className="dropdown-item" onClick={() => {
                                            setMenuOpen(false);
                                            setShowUserModal(true);
                                        }} style={{ borderTop: '1px solid #eee', marginTop: '5px', paddingTop: '10px' }}>
                                            👤 Alta de Nuevo Usuario
                                        </div>
                                    )}
                                    {['ADMINISTRADOR', 'GESTOR', 'SUPERVISOR', 'JEFE_TURNO', 'OFICIAL'].includes(userRol) && (
                                        <div className="dropdown-item" onClick={() => navigate('/crear-plantilla')}>
                                            💾 Crear Plantilla HPT
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    )}
                </div>
                
                {/* Título Central */}
                <div className="nav-center">
                    <span className="nav-title">PLANTA ASTE1 • GESTIONES HPT</span>
                </div>
                
                {/* Menú de Usuario (Derecha) */}
                <div className="nav-section" ref={userRef}>
                    <div className="user-trigger" onClick={() => { 
                        setUserMenuOpen(!userMenuOpen); 
                        setShowProfile(false); // Resetea la vista al abrir/cerrar
                    }}>
                        <span>👤 {nameUser}</span>
                    </div>
                    
                    {userMenuOpen && (
                        <div className="context-menu profile-context-menu">
                            {!showProfile && !showChangePass && (
                                <>
                                    <div className="dropdown-item" onClick={(e) => { e.stopPropagation(); setShowChangePass(true); }}>
                                        🔑 Cambiar contraseña
                                    </div>
                                    <div className="dropdown-item" onClick={(e) => { e.stopPropagation(); setShowProfile(true); }}>
                                        👤 Perfil
                                    </div>
                                    <div className="dropdown-item danger" onClick={logout}>🚪 Cerrar Sesión</div>
                                </>
                            )}
                                {/* VISTA 2: PERFIL DE USUARIO */}
                                {showProfile && (
                                    <div className="profile-dropdown-panel">
                                        <div className="profile-header">
                                            <span className="back-btn" onClick={(e) => { e.stopPropagation(); setShowProfile(false); }}>⬅ Volver</span>
                                            <strong>Datos del Perfil</strong>
                                        </div>
                                        <div className="profile-body">
                                            <div className="profile-row"><span>Usuario:</span> <strong>{perfilUsuario.usuario}</strong></div>
                                            <div className="profile-row"><span>Nombre:</span> <strong>{perfilUsuario.nombre} {perfilUsuario.apellidos}</strong></div>
                                            <div className="profile-row"><span>Correo:</span> <strong>{perfilUsuario.correo}</strong></div>
                                            <div className="profile-row"><span>Rol:</span> <strong>{perfilUsuario.rol}</strong></div>
                                            <div className="profile-row"><span>Grupo:</span> <strong>{perfilUsuario.grupo}</strong></div>
                                            {/* --- SECCIÓN DE FIRMA MAESTRA --- */}
                                            <hr className="profile-divider" />
                                            {/* --- SECCIÓN DE DELEGACIÓN POR VACACIONES (FECHAS) --- */}
                                            {['GESTOR', 'SUPERVISOR', 'JEFE_TURNO', 'PREVENCION', 'CALIDAD'].includes(userRol) && (
                                                <>
                                                    <hr className="profile-divider" />
                                                    <div className="profile-signature-section">
                                                        <span className="profile-signature-title" style={{ color: '#d32f2f' }}>🌴 Programar Vacaciones</span>
                                                        <span style={{ fontSize: '11px', color: '#666', marginBottom: '8px' }}>Programa quién firmará por ti durante tu ausencia. El sistema transferirá los permisos y correos automáticamente en esas fechas.</span>
                                                        
                                                        <div style={{ display: 'flex', gap: '5px', marginBottom: '5px' }}>
                                                            <input type="date" className="main-input" value={nuevaDelegacion.fecha_inicio} onChange={e => setNewDelegacion({...nuevaDelegacion, fecha_inicio: e.target.value})} title="Fecha Inicio" />
                                                            <input type="date" className="main-input" value={nuevaDelegacion.fecha_fin} onChange={e => setNewDelegacion({...nuevaDelegacion, fecha_fin: e.target.value})} title="Fecha Fin" />
                                                        </div>
                                                        <select style={{width: '80%'}} className="main-select mb-10" value={nuevaDelegacion.id_suplente} onChange={e => setNewDelegacion({...nuevaDelegacion, id_suplente: e.target.value})}>
                                                            <option value="">-- Selecciona a tu suplente --</option>
                                                            {usuariosList.filter(u => u.id_usuario !== uId).map(u => (
                                                                <option key={u.id_usuario} value={u.id_usuario}>{u.nombre} {u.apellidos} ({u.rol})</option>
                                                            ))}
                                                        </select>
                                                        <button className="btn-save" style={{ backgroundColor: '#d32f2f', padding: '6px' }} onClick={handleCrearDelegacion}>➕ Añadir Periodo</button>

                                                        {/* Lista de periodos programados */}
                                                        {misDelegaciones.length > 0 && (
                                                            <div style={{ marginTop: '15px', border: '1px solid #ccc', borderRadius: '4px' }}>
                                                                {misDelegaciones.map(d => (
                                                                    <div key={d.id_delegacion} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px', borderBottom: '1px solid #eee', fontSize: '11px' }}>
                                                                        <span style={{color: '#333'}}><strong>{new Date(d.fecha_inicio).toLocaleDateString()}</strong> al <strong>{new Date(d.fecha_fin).toLocaleDateString()}</strong><br/>{d.suplente_nombre} {d.suplente_apellidos}</span>
                                                                        <button onClick={() => handleEliminarDelegacion(d.id_delegacion)} style={{ background: 'none', border: 'none', color: '#d32f2f', cursor: 'pointer', fontWeight: 'bold' }}>X</button>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </>
                                            )}
                                            <div className="profile-signature-section">
                                                <span className="profile-signature-title">Mi Firma Digital Autorizada</span>
                                                
                                                {firmaGuardada ? (
                                                    <>
                                                        <div className="profile-signature-box">
                                                            <img src={firmaGuardada} alt="Firma Maestra" className="profile-signature-img" />
                                                        </div>
                                                        <button className="btn-profile-sign" onClick={(e) => { e.stopPropagation(); setShowSignaturePad(true); }}>
                                                            Modificar Firma
                                                        </button>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span className="profile-signature-empty">Aún no has guardado una firma</span>
                                                        <button className="btn-profile-sign create" onClick={(e) => { e.stopPropagation(); setShowSignaturePad(true); }}>
                                                            ✍️ Crear Firma Maestra
                                                        </button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {/* VISTA 3: CAMBIAR CONTRASEÑA */}
                                {showChangePass && (
                                    <div className="profile-dropdown-panel">
                                        <div className="profile-header">
                                            <span className="back-btn" onClick={(e) => { e.stopPropagation(); setShowChangePass(false); }}>⬅ Volver</span>
                                            <strong>Cambiar Contraseña</strong>
                                        </div>
                                        <div className="profile-body">
                                            <form onSubmit={handleUpdatePassword} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                <input type="password" required className="main-input" placeholder="Contraseña actual" 
                                                    value={passwords.actual} onChange={e => setPasswords({...passwords, actual: e.target.value})} 
                                                />
                                                <input type="password" required className="main-input" placeholder="Nueva contraseña" 
                                                    value={passwords.nueva} onChange={e => setPasswords({...passwords, nueva: e.target.value})} 
                                                />
                                                <input type="password" required className="main-input" placeholder="Repita nueva contraseña" 
                                                    value={passwords.confirmacion} onChange={e => setPasswords({...passwords, confirmacion: e.target.value})} 
                                                />
                                                
                                                {/* Mensajes de feedback */}
                                                {passMsg.error && <span style={{ color: '#d32f2f', fontSize: '11px', fontWeight: 'bold' }}>❌ {passMsg.error}</span>}
                                                {passMsg.success && <span style={{ color: '#2e7d32', fontSize: '11px', fontWeight: 'bold' }}>✅ {passMsg.success}</span>}
                                                
                                                <button type="submit" className="btn-save" style={{ padding: '8px', fontSize: '13px', marginTop: '5px' }}>
                                                    Actualizar
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                )}
                        </div>
                    )}
                </div>
            </nav>

            {/* --- BANNER DE ALERTAS --- */}
            {/* Solo se aplica si tiene alguna firma pendiente */}
            {hptsPendientesMiFirma.length > 0 && (
                <div className="alert-banner stacked">
                    <div className="d-flex align-center w-100 gap-10">
                        <span className="alert-icon">⚠️</span>
                        <div className="flex-1">
                            <strong>Atención: Tienes {hptsPendientesMiFirma.length} {hptsPendientesMiFirma.length === 1 ? 'firma pendiente' : 'firmas pendientes'} de tu rol.</strong>
                        </div>
                        
                        {/* Lógica del Botón Dinámico */}
                        <button 
                            className="btn-alert-action" 
                            onClick={() => {
                                if (hptsPendientesMiFirma.length === 1) {
                                    navigate(`/detalles-hpt/${hptsPendientesMiFirma[0].id_hpt}`);
                                } else {
                                    setShowPendingList(!showPendingList);
                                }
                            }}
                        >
                            {hptsPendientesMiFirma.length === 1 
                                ? 'Ir a firmar' 
                                : (showPendingList ? 'Ocultar lista 🔼' : 'Ver firmas pendientes 🔽')
                            }
                        </button>
                    </div>

                    {/* Mini lista desplegable (Solo si hay > 1 y se ha pulsado el botón) */}
                    {hptsPendientesMiFirma.length > 1 && showPendingList && (
                        <div className="mt-15 pending-list-container">
                            {hptsPendientesMiFirma.map(hpt => (
                                <div 
                                    key={hpt.id_hpt} 
                                    className="d-flex align-center justify-between pending-list-item" 
                                    onClick={() => navigate(`/detalles-hpt/${hpt.id_hpt}`)}
                                >
                                    <div>
                                        <strong className="pending-item-title">OT: {hpt.ot_referencia}</strong> <br/>
                                        <span className="pending-item-subtitle">
                                            ⚙️ {hpt.codigo_activo} - {hpt.den_act_descripcion}
                                        </span><br/>
                                        <span className="pending-item-subtitle"> 
                                            👤 {hpt.nombre} {hpt.apellidos}
                                        </span>
                                    </div>
                                    <div className="pending-item-action">
                                        FIRMAR →
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {/* --- CONTENIDO PRINCIPAL --- */}
            <div className="dashboard-content">

                {/* --- COLUMNA HPT --- */}
                <div className="dash-column">
                    <div className="column-header">
                        <div className="d-flex align-center gap-10">
                            <span style={{fontSize: '20px'}}>📋</span>
                            <h3 className="col-title title-hpt">Planificación (HPT)</h3>
                        </div>
                        {/* Conteo de HPTs atrasadas (menores de hoy) vs Total general */}
                        <div className="nav-section counter-wrapper" ref={counterHptRef}>
                            <div 
                                className="counter-badge counter-hpt counter-clickable" 
                                onClick={() => setShowHptCounts(!showHptCounts)}
                            >
                                {hptsNoFinalizadasCount} / {hptsTotalCount} <span className="counter-small-text">NUEVAS</span>
                            </div>

                            {/*DESPLEGABLE CON DESGLOSE POR DEPARTAMENTO*/}
                            {showHptCounts && (
                                <div className="dropdown-menu dropdown-stats">
                                    <strong className="dropdown-stats-title">
                                        DESGLOSE POR DEPARTAMENTO
                                    </strong>
                                    
                                    <div className="stats-list">
                                        <div className="stats-row stats-row-clickable" onClick={() => handleFiltroRapido('MECANICO')}>
                                            <span>⚙️ Mecánico:</span> <strong>{((desgloseHptsNuevas['MECANICO'] || 0) + (desgloseHptsNuevas['SPMecanico'] || 0))} / {((desgloseHpts['MECANICO'] || 0) + (desgloseHpts['SPMecanico'] || 0))}</strong>
                                        </div>
                                        <div className="stats-row stats-row-clickable" onClick={() => handleFiltroRapido('CAMPO SOLAR')}>
                                            <span>☀️ Campo Solar:</span> <strong>{((desgloseHptsNuevas['CAMPO SOLAR'] || 0) + (desgloseHptsNuevas['SPCampoSolar'] || 0))} / {((desgloseHpts['CAMPO SOLAR'] || 0) + (desgloseHpts['SPCampoSolar'] || 0))}</strong>
                                        </div>
                                        <div className="stats-row stats-row-clickable" onClick={() => handleFiltroRapido('ELECTRICOS')}>
                                            <span>⚡ Eléctricos:</span> <strong>{((desgloseHptsNuevas['ELECTRICOS'] || 0) + (desgloseHptsNuevas['SPElectrico'] || 0))} / {((desgloseHpts['ELECTRICOS'] || 0) + (desgloseHpts['SPElectrico'] || 0))}</strong>
                                        </div>
                                        <div className="stats-row stats-row-clickable" onClick={() => handleFiltroRapido('INSTRUMENTACION')}>
                                            <span>🎛️ Instrumentación:</span> <strong>{((desgloseHptsNuevas['INSTRUMENTACION'] || 0) + (desgloseHptsNuevas['SPInstrumentacion'] || 0))} / {((desgloseHpts['INSTRUMENTACION'] || 0) + (desgloseHpts['SPInstrumentacion'] || 0))}</strong>
                                        </div>
                                        <div className="stats-row stats-row-clickable" onClick={() => handleFiltroRapido('QUIMICO')}>
                                            <span>🧪 Químico:</span> <strong>{((desgloseHptsNuevas['QUIMICO'] || 0) + (desgloseHptsNuevas['SPQuimico'] || 0))} / {((desgloseHpts['QUIMICO'] || 0) + (desgloseHpts['SPQuimico'] || 0))}</strong>
                                        </div>
                                        <div className="stats-row stats-row-clickable" onClick={() => handleFiltroRapido('OPERACION')}>
                                            <span>🏭 Operación:</span> <strong>{desgloseHptsNuevas['OPERACION'] || 0}/{desgloseHpts['OPERACION'] || 0}</strong>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                   {/* Buscador inteligente */}
                    <input 
                        type="text" 
                        placeholder="🔍 Buscar OT (historial completo)..." 
                        className="search-bar"
                        value={searchHPT}
                        onChange={(e) => {
                            setSearchHPT(e.target.value);
                            setFilterGroup('');
                        }}
                    />
                    {filterGroup && (
                        <div className='filter-departament'>
                            <span className="id-badge">
                                Filtrando por: <strong>{filterGroup}</strong> 
                                <button 
                                    onClick={() => setFilterGroup('')} 
                                >
                                    ✕
                                </button>
                            </span>
                        </div>
                    )}


                    {/* Lista de Tarjetas HPT */}
                    <div className="card-list">
                        {hptsParaMostrar.map(hpt => (
                            // El borde izquierdo se pinta ROJO fuerte si al usuario le toca firmar.
                            <div 
                                key={hpt.id_hpt} 
                                className={`dash-card hpt-card ${(hpt.pendiente_de === 'COMPLETO' && hpt.fecha_prevista > hoy)  ? 'signature-finish' : meTocaFirmar(hpt) ? 'requires-signature' : '' }`}
                            >
                                <div className="card-header-flex">
                                    <div className="id-badge hpt-ot-badge">OT: {hpt.ot_referencia}</div>
                                    
                                    {/* Etiqueta de estado dinámica */}
                                    <div className="d-flex align-center">
                                        <span className={`status-pill ${hpt.pendiente_de === 'COMPLETO' ? 'complete' : 'waiting'}`}>
                                            {(hpt.pendiente_de === 'COMPLETO' && hpt.fecha_prevista > hoy) ? '✍️ PLANIFICACIÓN COMPLETADA' : `⏳ ESPERA: ${hpt.pendiente_de}`}
                                        </span>
                                        
                                        {/* Botón de borrar solo para GESTOR o ADMINISTRADOR */}
                                        {(userRol === 'ADMINISTRADOR' || userRol === 'GESTOR') && (
                                            <button 
                                                className="btn-delete-dash" 
                                                title="Eliminar Planificación"
                                                onClick={(e) => { 
                                                    e.stopPropagation(); 
                                                    handleDeleteHPT(hpt.id_hpt, hpt.ot_referencia); 
                                                }}
                                            >
                                                ✖
                                            </button>
                                        )}
                                    </div>
                                </div>

                                {/* INFO ACTIVO HPT */}
                                <div className="asset-box">
                                    <div className="asset-row-flex">
                                        <span className="icon-circle-small">📃</span>
                                        <div className="asset-info-wrapper">
                                            <span className="asset-name-text">
                                                🪧 {hpt.titulo}
                                            </span>
                                            <span className="asset-code-text">
                                                🏷️ {hpt.codigo_activo || 'S/A'}
                                            </span>
                                            <span className="asset-name-text">
                                                ⚙️ {hpt.den_act_descripcion}
                                            </span>
                                            <span className="asset-loc-tag">
                                                📍 {hpt.nombre_zona || 'Planta General'}
                                            </span>
                                            <span className="asset-loc-tag">
                                                👤 {hpt.nombre + " " + hpt.apellidos + " " + hpt.creador_grupo || ''}
                                            </span>
                                            <span className="asset-desc_tag">
                                                👷 {hpt.descripcion_trabajo ? hpt.descripcion_trabajo.split('.')[0] : ''}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Botón de entrada a Detalles HPT */}
                                <div className="card-footer-hpt">
                                    <div className='asset-info-date'>📅 {hpt.fecha_prevista} ➡️ (⏳{hpt.dias_previstos} {hpt.dias_previstos > 1 ? "Días" :"Día"})</div>
                                    <button className="btn-view-hpt" onClick={() => navigate(`/detalles-hpt/${hpt.id_hpt}`)}>
                                        VER DETALLES
                                    </button>
                                </div>
                            </div>
                        ))}
                        {/* Mensaje de vacío si no hay resultados en el array */}
                        {hptsParaMostrar.length === 0 && <p className="empty-text-msg">No se encontraron resultados.</p>}
                    </div>
                </div>
                
                {/* COLUMNA PTW (Comentada en el código original) */}
                
                {/*
                <div className="dash-column">
                    <div className="column-header">
                        <div className="d-flex align-center gap-10">
                            <span style={{fontSize: '20px'}}>📄</span>
                            <h3 className="col-title title-ptw">Ejecución (PTW)</h3>
                        </div>
                        <div className="nav-section counter-wrapper" ref={counterPtwRef}>
                            <div 
                                className="counter-badge counter-ptw counter-clickable" 
                                onClick={() => setShowPtwCounts(!showPtwCounts)}
                            >
                                {ptwsNoCerradosCount} / {ptwsTotalCount} <span className="counter-small-text">ACTIVOS</span>
                            </div>

                            {showPtwCounts && (
                                <div className="dropdown-menu dropdown-stats" style={{ left: 0, right: 'auto' }}>
                                    <strong className="dropdown-stats-title" style={{color: '#1a237e', borderColor: '#1a237e'}}>
                                        DESGLOSE POR DEPARTAMENTO
                                    </strong>
                                    <div className="stats-list">
                                        <div className="stats-row stats-row-clickable" onClick={() => handleFiltroRapidoPTW('MECANICO')}>
                                            <span>⚙️ Mecánico:</span> <strong>{((desglosePtws['MECANICO'] || 0) + (desglosePtws['SPMecanico'] || 0))}</strong>
                                        </div>
                                        <div className="stats-row stats-row-clickable" onClick={() => handleFiltroRapidoPTW('CAMPO SOLAR')}>
                                            <span>☀️ Campo Solar:</span> <strong>{((desglosePtws['CAMPO SOLAR'] || 0) + (desglosePtws['SPCampoSolar'] || 0))}</strong>
                                        </div>
                                        <div className="stats-row stats-row-clickable" onClick={() => handleFiltroRapidoPTW('ELECTRICOS')}>
                                            <span>⚡ Eléctricos:</span> <strong>{((desglosePtws['ELECTRICOS'] || 0) + (desglosePtws['SPElectrico'] || 0))}</strong>
                                        </div>
                                        <div className="stats-row stats-row-clickable" onClick={() => handleFiltroRapidoPTW('INSTRUMENTACION')}>
                                            <span>🎛️ Instrumentación:</span> <strong>{((desglosePtws['INSTRUMENTACION'] || 0) + (desglosePtws['SPInstrumentacion'] || 0))}</strong>
                                        </div>
                                        <div className="stats-row stats-row-clickable" onClick={() => handleFiltroRapidoPTW('QUIMICO')}>
                                            <span>🧪 Químico:</span> <strong>{((desglosePtws['QUIMICO'] || 0) + (desglosePtws['SPQuimico'] || 0))}</strong>
                                        </div>
                                        <div className="stats-row stats-row-clickable" onClick={() => handleFiltroRapidoPTW('OPERACION')}>
                                            <span>🏭 Operación:</span> <strong>{(desglosePtws['Operacion'] || 0) + (desglosePtws['OPERACION'] || 0) + (desglosePtws['JEFE_TURNO'] || 0)}</strong>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    
                    <input 
                        type="text" 
                        placeholder="🔍 Buscar ID (historial completo)..." 
                        className="search-bar"
                        value={searchPTW}
                        onChange={(e) => setSearchPTW(e.target.value)}
                    />

                    {filterGroupPTW && (
                        <div className='filter-departament'>
                            <span className="id-badge" style={{backgroundColor: '#f0f4f8', borderColor: '#1a237e', color: '#1a237e'}}>
                                Filtrando por: <strong>{filterGroupPTW}</strong> 
                                <button onClick={() => setFilterGroupPTW('')}>✕</button>
                            </span>
                        </div>
                    )}

                    <div className="card-list">
                        {ptwsParaMostrar.map(ptw => {
                            const config = getStatusConfig(ptw.estado);
                            return (
                                <div key={ptw.id_serial_interno} className="dash-card ptw-card">
                                    <div className="card-header-flex">
                                        <div className="id-badge ptw-id-badge">ID: {ptw.id_ptw_formato}</div>
                                        <span className="status-pill" style={{ backgroundColor: config.color }}>
                                            <span style={{ marginRight: '5px' }}>{config.icon}</span>
                                            {ptw.estado ? ptw.estado.toUpperCase() : 'CREADO'}
                                        </span>
                                    </div>

                                    <div className="asset-box">
                                        <div className="asset-row-flex">
                                            <span className="icon-circle-small">⚙️</span>
                                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                                <span className="asset-code-text">{ptw.codigo_activo || 'S/A'}</span>
                                                <span className="asset-name-text">{ptw.den_act_snapshot}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="scope-box">
                                        <p className="scope-text">
                                            <span style={{ marginRight: '8px' }}>🚧</span> 
                                            {ptw.alcance}
                                        </p>
                                    </div>

                                    <div className="card-footer-ptw">
                                        <div className="datetime-box">
                                            <span className="date-time-tag">📅 {ptw.fecha_trabajo ? new Date(ptw.fecha_trabajo).toLocaleDateString() : '--/--/--'}</span>
                                            <span className="date-time-tag">🕒 {ptw.rango_horario || 'S/H'}</span>
                                        </div>
                                        <button className="btn-manage-ptw" onClick={() => navigate(`/detalles-ptw/${ptw.id_serial_interno}`)}>
                                            GESTIONAR →
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                        {ptwsParaMostrar.length === 0 && <p className="empty-text-msg">No se encontraron resultados.</p>}
                    </div>
                </div> 
                */}
                
                {/* === MODAL FLOTANTE DE ANEXOS === */}
                {showAnexosModal && (
                    <div className="modal-overlay" onClick={() => setShowAnexosModal(false)}>
                        <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ width: '650px', maxWidth: '95%' }}>
                            <button className="close-btn" onClick={() => setShowAnexosModal(false)}>✖</button>
                            
                            {/* VISTA 1: GRID DE ICONOS */}
                            {!anexoSeleccionado ? (
                                <div style={{ width: '100%' }}>
                                    <h3 className="section-title text-center" style={{ borderBottom: 'none' }}>Gestión de Anexos Centralizada</h3>
                                    <div className="anexos-grid">
                                        <div className="anexo-card" onClick={() => handleCargarListaAnexos('escalera')}>
                                            <span style={{ fontSize: '30px' }}>🪜</span> Escaleras
                                        </div>
                                        <div className="anexo-card" onClick={() => handleCargarListaAnexos('plataforma')}>
                                            <span style={{ fontSize: '30px' }}>🏗️</span> Plataformas
                                        </div>
                                        <div className="anexo-card" onClick={() => handleCargarListaAnexos('carretilla')}>
                                            <span style={{ fontSize: '30px' }}>🚜</span> Carretillas
                                        </div>
                                        <div className="anexo-card" onClick={() => handleCargarListaAnexos('quimico')}>
                                            <span style={{ fontSize: '30px' }}>🧪</span> Químicos
                                        </div>
                                        <div className="anexo-card" onClick={() => handleCargarListaAnexos('confinados')}>
                                            <span style={{ fontSize: '30px' }}>🔴</span> Confinados
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div style={{ width: '100%'}}>
                                     {/* VISTA 2: LISTADO DIVIDIDO */}
                                    <div className="d-flex align-center gap-10 mb-20" style={{ borderBottom: '2px solid #eee', paddingBottom: '10px' }}>
                                        <span className="back-btn" onClick={() => setAnexoSeleccionado(null)}>⬅ Volver</span>
                                        <h3 style={{ margin: 0, color: '#1a237e', textTransform: 'uppercase' }}>Anexos de {anexoSeleccionado}</h3>
                                    </div>
                                    
                                    <button className="btn-save w-100 mb-20" onClick={() => {
                                        setShowAnexosModal(false);
                                        navigate(`/solicitud-${anexoSeleccionado}`); // Te lleva a crear uno nuevo vacío
                                    }}>
                                        ➕ Crear Nuevo Anexo Independiente
                                    </button>

                                    {loadingAnexos ? <div className="text-center" style={{ padding: '30px' }}>Cargando datos...</div> : (
                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                                            {/* COLUMNA 1: CON HPT */}
                                            <div>
                                                <h4 style={{ color: '#2e7d32', borderBottom: '2px solid #2e7d32', paddingBottom: '5px', margin: '0 0 10px 0' }}>
                                                    Vinculados a HPT
                                                </h4>
                                                <ul className="anexos-list">
                                                    {listaAnexos.filter(a => a.id_hpt).map(a => (
                                                        <li key={a.id} onClick={() => navigate(`/detalles-hpt/${a.id_hpt}`)}>
                                                            <strong>OT / HPT: {a.id_hpt}</strong><br/>
                                                            <span className="text-muted-small">📅 {a.fecha || 'Sin fecha'}</span><br/>
                                                            <span style={{ fontSize: '11px' }}>Ref: {a.referencia || 'N/A'}</span>
                                                        </li>
                                                    ))}
                                                    {listaAnexos.filter(a => a.id_hpt).length === 0 && <p className="text-muted-small">No hay anexos vinculados.</p>}
                                                </ul>
                                            </div>

                                            {/* COLUMNA 2: INDEPENDIENTES */}
                                            <div>
                                                <h4 style={{ color: '#d32f2f', borderBottom: '2px solid #d32f2f', paddingBottom: '5px', margin: '0 0 10px 0' }}>
                                                    Independientes
                                                </h4>
                                                <ul className="anexos-list">
                                                    {listaAnexos.filter(a => !a.id_hpt).map(a => (
                                                        <li key={a.id} onClick={() => {
                                                            // Te lleva a la ruta correspondiente pasando el ID
                                                            setShowAnexosModal(false);
                                                            navigate(`/solicitud-${anexoSeleccionado}/${a.id}`); 
                                                        }}>
                                                            <strong>ID: {a.id.toString().substring(0, 10)}{a.id.toString().length > 10 ? '...' : ''}</strong><br/>
                                                            <span className="text-muted-small">📅 {a.fecha || 'Sin fecha'}</span><br/>
                                                            <span style={{ fontSize: '11px' }}>Ref: {a.referencia || 'N/A'}</span>
                                                        </li>
                                                    ))}
                                                    {listaAnexos.filter(a => !a.id_hpt).length === 0 && <p className="text-muted-small">No hay anexos independientes.</p>}
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                )}

            {/* === MODAL FLOTANTE: SOLICITUD DE COMPRAS === */}
            {showComprasModal && (
                <div className="modal-overlay" onClick={() => setShowComprasModal(false)}>
                    <div className="modal-content" onClick={e => e.stopPropagation()} style={{ width: '800px', maxWidth: '95%', maxHeight: '90vh' }}>
                        <button className="close-btn" onClick={() => setShowComprasModal(false)}>✖</button>
                        
                        <div style={{ width: '100%' }}>
                            <div className="d-flex align-center justify-between mb-15" style={{ borderBottom: '2px solid #003366', paddingBottom: '10px' }}>
                                <h3 style={{ margin: 0, color: '#003366' }}>📦 Solicitudes de Compras y Almacén</h3>
                                <button 
                                    className="btn-save" 
                                    style={{ backgroundColor: '#003366', padding: '8px 16px', fontSize: '13px' }}
                                    onClick={() => {
                                        setShowComprasModal(false);
                                        navigate('/crear-compra');
                                    }}
                                >
                                    ➕ Nueva Solicitud
                                </button>
                            </div>

                            <input 
                                type="text" 
                                placeholder="🔍 Buscar por Nº solicitud, depto, solicitante o tipo..." 
                                className="search-bar"
                                style={{ marginBottom: '15px' }}
                                value={searchCompra}
                                onChange={e => setSearchCompra(e.target.value)}
                            />

                            <select 
                                className="main-select" 
                                style={{ width: '220px', margin: 0 }}
                                value={filterPendiente}
                                onChange={e => setFilterPendiente(e.target.value)}
                            >
                                <option value="">Todas las firmas</option>
                                <option value="SOLICITANTE">Pendiente: Solicitante</option>
                                <option value="ALMACEN">Pendiente: Almacén</option>
                                <option value="SUPERVISOR">Pendiente: Supervisor</option>
                                <option value="SUPERVISOR_COSTES">Pendiente: Supervisor (Costes)</option>
                                <option value="APROBACION_PRL">Pendiente: PRL</option>
                                <option value="RESPONSABLE">Pendiente: Responsable / Jefa</option>
                                <option value="JEFA_MANTENIMIENTO">Pendiente: Jefa Mant.</option>
                                <option value="JO">Pendiente: JO</option>
                                <option value="JEFE_CT">Pendiente: Jefe CT</option>
                                <option value="ADMINISTRACION">Pendiente: Administración</option>
                                <option value="COMPLETO">Completadas</option>
                            </select>

                            {loadingCompras ? (
                                <div className="text-center" style={{ padding: '30px' }}>Cargando solicitudes...</div>
                            ) : (
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                                    {/* COLUMNA 1: EN PROCESO */}
                                    <div>
                                        <h4 style={{ color: '#f57c00', borderBottom: '2px solid #f57c00', paddingBottom: '5px', margin: '0 0 10px 0' }}>
                                            ⏳ En Proceso ({comprasEnProceso.length})
                                        </h4>
                                        <ul className="anexos-list">
                                            {comprasEnProceso.map(c => (
                                                <li 
                                                    key={c.id_solicitud} 
                                                    onClick={() => {
                                                        setShowComprasModal(false);
                                                        navigate(`/compras/${c.id_solicitud}`);
                                                    }}
                                                >
                                                    <div className="d-flex justify-between">
                                                        <strong>
                                                            #{c.id_solicitud} {c.titulo ? `- ${c.titulo}` : ''} <span style={{fontWeight: 'normal'}}>({c.tipo_solicitud})</span>
                                                        </strong>
                                                        <span style={{ fontSize: '10px', color: '#f57c00', fontWeight: 'bold' }}>
                                                            Firma: {c.pendiente_de}
                                                        </span>
                                                        {(userRol === 'ADMINISTRADOR' || userRol === 'GESTOR' || (userRol === 'OFICIAL' && uGrupo === 'ALMACEN')) && (
                                                            <button 
                                                                className="btn-delete-dash" 
                                                                title="Eliminar Solicitud"
                                                                style={{ marginLeft: '10px', background: 'none', border: 'none', color: '#d32f2f', cursor: 'pointer', fontSize: '12px' }}
                                                                onClick={(e) => { 
                                                                    e.stopPropagation(); 
                                                                    handleDeleteCompra(c.id_solicitud); 
                                                                }}
                                                            >
                                                                ✖ Borrar
                                                            </button>
                                                        )}
                                                    </div>
                                                    <span className="text-muted-small">📅 {new Date(c.fecha_creacion).toLocaleDateString()} | Depto: {c.departamento}</span><br/>
                                                    <span style={{ fontSize: '11px', color: '#555' }}>
                                                        👤 Solicitante: {c.solicitante_nombre} {c.solicitante_apellidos}
                                                    </span>
                                                </li>
                                            ))}
                                            {comprasEnProceso.length === 0 && <p className="text-muted-small">No hay solicitudes en proceso.</p>}
                                        </ul>
                                    </div>

                                    {/* COLUMNA 2: TERMINADAS */}
                                    <div>
                                        <h4 style={{ color: '#2e7d32', borderBottom: '2px solid #2e7d32', paddingBottom: '5px', margin: '0 0 10px 0' }}>
                                            ✅ Terminadas ({comprasTerminadas.length})
                                        </h4>
                                        <ul className="anexos-list">
                                            {comprasTerminadas.map(c => (
                                                <li 
                                                    key={c.id_solicitud} 
                                                    onClick={() => {
                                                        setShowComprasModal(false);
                                                        navigate(`/compras/${c.id_solicitud}`);
                                                    }}
                                                >
                                                    <div className="d-flex justify-between">
                                                        <strong>
                                                            #{c.id_solicitud} {c.titulo ? `- ${c.titulo}` : ''} <span style={{fontWeight: 'normal'}}>({c.tipo_solicitud})</span>
                                                        </strong>
                                                        <span style={{ fontSize: '10px', color: '#2e7d32', fontWeight: 'bold' }}>
                                                            COMPLETADA
                                                        </span>
                                                    </div>
                                                    <span className="text-muted-small">📅 {new Date(c.fecha_creacion).toLocaleDateString()} | Depto: {c.departamento}</span><br/>
                                                    <span style={{ fontSize: '11px', color: '#555' }}>
                                                        👤 Solicitante: {c.solicitante_nombre} {c.solicitante_apellidos}
                                                    </span>
                                                </li>
                                            ))}
                                            {comprasTerminadas.length === 0 && <p className="text-muted-small">No hay solicitudes terminadas.</p>}
                                        </ul>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* === MODAL FLOTANTE: CREAR NUEVO USUARIO === */}
            {showUserModal && (
                <div className="modal-overlay" onClick={() => setShowUserModal(false)}>
                    <div className="modal-content" onClick={e => e.stopPropagation()} style={{ width: '550px', maxWidth: '95%' }}>
                        <button className="close-btn" onClick={() => setShowUserModal(false)}>✖</button>
                        
                        <h3 className="section-title text-center" style={{ color: '#1a237e' }}>👤 Crear Nuevo Usuario</h3>
                        
                        <form onSubmit={handleCreateUser} className="d-flex" style={{ flexDirection: 'column', gap: '15px', marginTop: '20px' }}>
                            <div className="info-box">
                                <span className="info-label">Nombre de Usuario *</span>
                                <input required type="text" name="usuario" value={newUser.usuario} onChange={handleNewUserChange} className="main-input" placeholder="Ej: mmartinez" />
                            </div>
                            
                            <div className="row">
                                <div className="info-box flex-1">
                                    <span className="info-label">Nombre *</span>
                                    <input required type="text" name="nombre" value={newUser.nombre} onChange={handleNewUserChange} className="main-input" placeholder="Ej: María" />
                                </div>
                                <div className="info-box flex-1">
                                    <span className="info-label">Apellidos *</span>
                                    <input required type="text" name="apellidos" value={newUser.apellidos} onChange={handleNewUserChange} className="main-input" placeholder="Ej: Martínez Pérez" />
                                </div>
                            </div>
                            
                            <div className="info-box">
                                <span className="info-label">Correo Electrónico *</span>
                                <input required type="email" name="correo" value={newUser.correo} onChange={handleNewUserChange} className="main-input" placeholder="Ej: mmartinez@empresa.com" />
                            </div>
                            
                            <div className="row">
                                <div className="info-box flex-1">
                                    <span className="info-label">Rol *</span>
                                    <select required name="rol" value={newUser.rol} onChange={handleNewUserChange} className="main-select">
                                        <option value="">-- Seleccionar --</option>
                                        {/* Solo los Administradores pueden crear Gestores */}
                                        <option value="GESTOR">GESTOR</option>
                                        <option value="ADMINISTRACION">ADMINISTRACION</option>
                                        <option value="SUPERVISOR">SUPERVISOR</option>
                                        <option value="JEFE_TURNO">JEFE DE TURNO</option>
                                        <option value="PREVENCION">TÉCNICO PREVENCIÓN (PRL)</option>
                                        <option value="CALIDAD">TÉCNICO CALIDAD</option>
                                        <option value="OFICIAL">OFICIAL</option>
                                    </select>
                                </div>
                                <div className="info-box flex-1">
                                    <span className="info-label">Departamento / Grupo *</span>
                                    <select required name="grupo" value={newUser.grupo} onChange={handleNewUserChange} className="main-select">
                                        <option value="">-- Seleccionar --</option>
                                        <option value="OPERACION">Oficial Operación</option>
                                        <option value="Operacion">Gestor Operacion</option>
                                        <option value="JEFE_TURNO">JEFE TURNO</option>
                                        <option value="Mantenimiento">Gestor Mantenimiento</option>
                                        <option value="MECANICO">Oficiales Mecánicos</option>
                                        <option value="ELECTRICOS">Oficiales Eléctricos</option>
                                        <option value="INSTRUMENTACION">Oficiales de Instrumentación</option>
                                        <option value="CAMPO SOLAR">Oficiales Campo Solar</option>
                                        <option value="QUIMICO">Oficiales Departamento Químico</option>
                                        <option value="SPMecanico">Supervisor Mecánicos</option>
                                        <option value="SPElectrico">Supervisor Eléctricos</option>
                                        <option value="SPInstrumentacion">Supervisor de Instrumentación</option>
                                        <option value="SPCampoSolar">Supervisor Campo Solar</option>
                                        <option value="SPQuimico">Supervisor Departamento Químico</option>
                                        <option value="PREVENCION">Departamento PRL</option>
                                        <option value="CALIDAD">TÉCNICO CALIDAD</option>
                                        <option value="ALMACEN">Almacenero</option>
                                        <option value="ADMINISTRACION">Administración / Compras</option>
                                        <option value="SOLAR">Gestor Planta Solar</option>
                                        <option value="EOLICO">Gestor Planta Eolica</option>
                                    </select>
                                </div>
                            </div>

                            <div className="alert-banner" style={{ margin: '10px 0 0 0', padding: '12px', backgroundColor: '#e3f2fd', borderColor: '#bbdefb', borderRadius: '6px' }}>
                                <span style={{ fontSize: '13px', color: '#1565c0', lineHeight: '1.4' }}>
                                    ℹ️ La contraseña generada por defecto será: <strong>AstesAB</strong><br/>
                                    Se le pedirá al trabajador que la cambie desde su "Perfil" tras acceder por primera vez.
                                </span>
                            </div>

                            <button type="submit" className="btn-save mt-10" style={{ padding: '12px', fontSize: '15px' }}>
                                💾 Registrar Trabajador
                            </button>
                        </form>
                    </div>
                </div>
            )}

            </div>
            {showSignaturePad && (
                <SignaturePad 
                    onSave={handleGuardarFirma} 
                    onCancel={() => setShowSignaturePad(false)} 
                />
            )}
        </div>
    );
};

export default DashboardScreen;